import React from "react";

const Resources = () => {
  return (
    <div className="flex justify-center items-center w-screen h-screen">
      <h1 className="text-gray-100 text-4xl">Coming Soon!</h1>
    </div>
  );
};

export default Resources;
